<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              placeholder="线路编号/线路名称/承运商搜索..."
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    高级搜索
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>

            <b-button
              v-allow="'actAdd'"
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="
                openEditPage({
                  pageType: 'add'
                })
              "
            >
              <b-icon-plus></b-icon-plus>新增
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>

    <el-dialog
      title="高级搜索"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      v-el-dialog-drag
      width="750px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="80px">
        <el-row :gutter="20">
          <el-form-item label="线路编号">
            <el-col :span="24">
              <el-input
                v-model="form.lineNo"
                placeholder="请输入线路编号"
                clearable
                size="small"
              >
              </el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="线路名称">
            <el-col :span="24">
              <el-input
                v-model="form.lineName"
                placeholder="请输入线路名称"
                clearable
                size="small"
              >
              </el-input>
            </el-col>
          </el-form-item>

          <el-form-item label="创建时间">
            <el-col :span="11">
              <el-date-picker
                v-model="form.beginDate"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-date-picker
                v-model="form.endDate"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
          </el-form-item>

          <el-form-item label="线路类型">
            <el-col :span="24">
              <el-checkbox-group v-model="form.lineTypeList">
                <el-checkbox label="R" name="type">收货线路</el-checkbox>
                <el-checkbox label="D" name="type">送货线路</el-checkbox>
                <el-checkbox label="Z" name="type">不指定</el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-form-item>

          <el-form-item label="有效状态">
            <el-col :span="24">
              <el-checkbox-group v-model="form.lineStatusList">
                <el-checkbox label="Y" name="type">已审核</el-checkbox>
                <el-checkbox label="N" name="type">新增</el-checkbox>
                <el-checkbox label="D" name="type">已删除</el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-form-item>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog"
          >取消查询</el-button
        >
        <el-button size="small" type="warning" @click="reset"
          >重置条件</el-button
        >
        <el-button size="small" type="primary" @click="advquery"
          >数据检索</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
// 初始表单
const initForm = {
  keyword: '',
  lineTypeList: ['R', 'D', 'Z'],
  lineStatusList: ['Y', 'N']
}

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm }
    }
  },
  created() {
    this.query()

    let _this = this
    this.$eventBus.$on('lineTableReload', function() {
      _this.query()
    })
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    // 打开编辑页面
    openEditPage({ pageType, code = '' }) {
      this.$router.push({
        name: 'contract-line-detail',
        params: { code, pageType }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
